import type { QueryClient } from '@tanstack/react-query';

let activeQueryClient: QueryClient | null = null;

export function setActivePrincipalQueryClient(client: QueryClient): () => void {
  activeQueryClient = client;
  return () => {
    if (activeQueryClient === client) activeQueryClient = null;
  };
}

export async function clearActivePrincipalQueries(): Promise<void> {
  const client = activeQueryClient;
  if (!client) return;
  if (activeQueryClient === client) activeQueryClient = null;
  const cancellation = client.cancelQueries();
  // Clear synchronously so an epoch change cannot leave old cached data
  // readable while cancellation callbacks settle.
  client.clear();
  await cancellation;
}

export async function refetchActiveStaleQueries(): Promise<void> {
  const client = activeQueryClient;
  if (!client) return;
  await client.refetchQueries({ type: 'active', stale: true });
}

/** Discard private query data while keeping the mounted client's registration. */
export async function clearActivePrincipalQueryData(): Promise<void> {
  const client = activeQueryClient;
  if (!client) return;
  const cancellation = client.cancelQueries();
  client.clear();
  await cancellation;
}
